<app-form-number-v2
  [(ngModel)]="value">
</app-form-number-v2>
